import AttendeeAction from './attendeeAction';
import Attendee from '../../../models/attendeeModel';
import ChangeRatePostAction from '../post-action/changeRatePostAction';
import { TICKET_SWAP_DISTRIBUTOR, DISTRIBUTOR_ID_FNAC, DISTRIBUTOR_ID_DIGITICK, DISTRIBUTOR_ID_TICKETNET } from '../../../models/distributor';
export default class ChangeRate extends AttendeeAction {
    static NAME = 'change_rate';
    static POST_ACTION_COMPONENT = ChangeRatePostAction;

    constructor({ items, sync, onClose, organization, event }) {
        super({ items, sync, onClose, organization, event });
    }

    static condition(attendee) {
        return (
            !['weez_invitation', 'weez_distributor'].includes(attendee.order.origin) &&
            ![DISTRIBUTOR_ID_FNAC, DISTRIBUTOR_ID_DIGITICK, DISTRIBUTOR_ID_TICKETNET, TICKET_SWAP_DISTRIBUTOR].includes(attendee.order.distributor) &&
            super.payment_plan_condition(attendee)
        );
    }

    get is_direct() {
        return true;
    }
    static is_available({ mode, event, feature_flags }) {
        return (
            mode === 'detail' &&
            !['closed'].includes(event.status) &&
            !event.removed &&
            !event.is_seated &&
            (feature_flags.includes('EO_EXTIA') || feature_flags.includes('EO_EXTI'))
        );
    }
    // global
    get needs_confirm() {
        return false;
    }

    // simple
    get needs_selection() {
        return false;
    }

    run() {
        return Promise.resolve(true);
    }

    runPostAction(form, attendee) {
        return Attendee.perform_action(this.constructor.NAME, form, { organization: this.organization, event: this.event, attendee: attendee });
    }

    get post_action() {
        return true;
    }

    onActionDone() {
        this.onClose();
    }
}
